import type { CSSProperties } from 'react';
import styles from './MainView.module.css';
import type { IHamburgerViewProperties } from './interface';

export enum StyleElement {
    Container = 'Container',
    BackgroundImage = 'BackgroundImage',
    BackgroundCover = 'BackgroundCover',
}

const DEFAULTS: Record<StyleElement, CSSProperties> = {
    [StyleElement.Container]: {},
    [StyleElement.BackgroundImage]: {},
    [StyleElement.BackgroundCover]: {},
};

const PROPS_APPLICATOR: Record<
    StyleElement,
    (properties: IHamburgerViewProperties) => CSSProperties
> = {
    [StyleElement.Container]: (properties: IHamburgerViewProperties) => ({
        backgroundColor: properties.backgroundColor,
    }),
    [StyleElement.BackgroundImage]: (properties: IHamburgerViewProperties) => ({}),
    [StyleElement.BackgroundCover]: (properties: IHamburgerViewProperties) => ({
        backgroundColor: properties.backgroundColor,
    }),
};

export function classNameForElement(
    element: StyleElement,
    model: IHamburgerViewProperties,
): string {
    const name = element.toString();
    return styles[name] ?? '';
}

export function styleForElement(
    element: StyleElement,
    properties: IHamburgerViewProperties,
): CSSProperties {
    const style = { ...DEFAULTS[element], ...PROPS_APPLICATOR[element](properties) };

    return style;
}
